<template>
    <div v-if="rams">
        <header class="bg-gray-100 text-gray-700">
            <div class="w-full mx-auto p-8 lg:p-12 flex flex-col md:flex-row-reverse" style="max-width: 1800px">
                <div class="md:w-72 mb-12 md:mb-0 md:ml-8 lg:ml-12">
                    <img src="https://insync.software/mobile-img/logo.svg" class="h-12">
                    <div class="mt-4">
                        <p class="font-semibold mb-1">Hambro Roofing Limited</p>
                        <p>Unit 2, 6-10 Lamson Road Rainham Essex RM13 9YY</p>
                        <p><a href="tel:01708803930">01708 803 930</a></p>
                        <p><a href="http://www.hambroroofing.com">www.hambroroofing.com</a></p>
                    </div>
                </div>
                <div class="flex-1">
                    <div class="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-8">
                        <div class="text-xl">
                            <h2 class="font-semibold text-gray-700">Date:</h2>
                            <p class="mt-1 text-gray-500">{{ moment(rams.date).format('DD/MM/YYYY') }}</p>
                        </div>
                        <div class="text-xl">
                            <h2 class="font-semibold text-gray-700">Principle Contractor:</h2>
                            <p class="mt-1 text-gray-500">{{ rams.principleContractor }}</p>
                        </div>
                        <div class="text-xl">
                            <h2 class="font-semibold text-gray-700">Site Address:</h2>
                            <p class="mt-1 text-gray-500">{{ rams.siteAddress }}</p>
                        </div>
                        <div class="text-xl">
                            <h2 class="font-semibold text-gray-700">Location of Works:</h2>
                            <p class="mt-1 text-gray-500">{{ rams.locationOfWorks }}</p>
                        </div>
                        <div class="text-xl">
                            <h2 class="font-semibold text-gray-700">Contract Manager:</h2>
                            <p class="mt-1 text-gray-500">{{ rams.contractManager }}</p>
                        </div>
                        <div class="text-xl">
                            <h2 class="font-semibold text-gray-700">Contract Reference:</h2>
                            <p class="mt-1 text-gray-500">{{ rams.contractReference }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <main class="bg-white text-gray-700">
            <div class="w-full mx-auto p-8 lg:p-12 pb-16 lg:pb-16 flex flex-col-reverse lg:flex-row-reverse"
                 style="max-width: 1800px">
                <div class="lg:w-72 mb-12 lg:mb-0 lg:ml-12 ">
                    <div class="space-y-8 sticky top-4">
                        <div class="text-left sm:text-right lg:text-left justify-center flex" @click="download">
                            <div
                                class="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 hover:text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 cursor-pointer">
                                <i class="fas fa-file-pdf mr-2"></i>
                                Download PDF
                            </div>
                        </div>
                        <div v-if="rams.response && rams.response.signature">
                            <h2 class="font-semibold text-lg text-gray-700">RAMS Approved</h2>
                            <p class="text-sm mt-1">This RAMS has been approved - Attendee signatures will be
                                shown as they are added to this RAMS.</p>
                            <div class="hidden lg:block" v-if="rams.response">
                                <p class="text-sm mt-1" v-if="rams.response">Approved by: <span
                                    class="font-semibold">{{ rams.response.name }}</span></p>
                                <p class="text-sm mt-1" v-if="rams.response">Signed:</p>
                                <img v-if="rams.response.signature" :src="rams.response.signature"
                                     style="width:100%; margin: 5px">
                            </div>
                        </div>
                        <div v-else-if="rams.response">
                            <h2 class="font-semibold text-lg text-gray-700">Rejected</h2>
                            <p class="text-sm mt-1">This RAMS has been rejected - We will be in touch shortly with an
                                update.</p>
                            <p class="text-sm mt-1" v-if="rams.response">Rejected by: <span
                                class="font-semibold">{{ rams.response.name }}</span></p>
                        </div>
                        <div v-else-if="rejectMode">
                            <h2 class="font-semibold text-lg text-gray-700">Comment and reject this RAMS</h2>
                            <p class="text-sm mt-1.5">Please click on any area of the RAMS you wish to comment on. Once
                                completed, please click "Finished rejecting this RAMS..." below.</p>
                            <p class="text-xs mt-2 text-gray-400">* This will open a small form to complete.</p>
                            <div @click="reject"
                                 class="mt-6 cursor-pointer flex items-center justify-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white hover:text-white bg-gray-700 hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                                <i class="fa fa-check mr-2"></i>
                                Finished rejecting this RAMS...
                            </div>
                            <div @click="rejectMode = false"
                                 class="mt-2 cursor-pointer flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-red-600 hover:text-red-600 bg-transparent hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500">
                                <i class="fa fa-times mr-2 text-red-400"></i>
                                Cancel rejecting this RAMS
                            </div>
                        </div>
                        <div v-else>

                            <div @click="approve"
                                 class="mt-6 cursor-pointer flex items-center justify-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white hover:text-white bg-gray-700 hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                                <i class="fa fa-check mr-2"></i>
                                Approve this RAMS...
                            </div>
                            <div @click="rejectMode = true"
                                 class="mt-2 cursor-pointer flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-red-600 hover:text-red-600 bg-transparent hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500">
                                <i class="fa fa-times mr-2 text-red-400"></i>
                                Comment and reject this RAMS...
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex-1" :key="renderKey">
                    <div class="text-5xl font-semibold text-gray-900">{{ rams.title }}</div>
                    <div class="mb-8 text-gray-500"><span class="font-semibold">Reference {{
                            rams.contractReference
                        }}</span> • {{ rams.package }}
                    </div>
                    <div class="text-gray-700">
                        <div v-for="(item,index) in rams.paragraphs" class="px-3 py-3 rounded-xl border-0 mt-1"
                             :class="((rejectMode && !readonly)?'hover:bg-red-50 cursor-pointer ':'')+((rejectMode && (typeof rejectData.paragraphs[index] !== 'undefined'))?'bg-red-50':'bg-white')"
                             @click="addReject('paragraphs',index)"
                        >
                            <div class="flex">
                                <div class="w-16 h-16 flex-shrink-0 p-0 mb-1 mr-1.5" v-if="item.iconClass">
                                    <div
                                        class="h-full w-full border border-gray-300 rounded-xl flex items-center align-middle">
                            <span class="text-gray-500 w-full text-center text-3xl"
                                  :class="item.iconClass"></span>
                                    </div>
                                </div>
                                <div>
                                    <h3 class="font-semibold text-gray-700">{{ item.title }}</h3>
                                    <p class="mt-1 whitespace-pre-wrap">{{ item.content }}</p>
                                </div>
                            </div>
                            <div class="p-2 text-red-500"
                                 :ref="'paragraphs_'+index"
                                 v-if="rejectMode && (typeof rejectData.paragraphs[index] !== 'undefined')">
                                <div class="flex">
                                    <label>Your rejection comments:</label>
                                    <div>
                                        <button v-if="!readonly"
                                                class="px-2 py-1 text-xs text-gray-600 hover:text-red-600 border ml-2 border-gray-200 rounded-lg bg-white"
                                                @click="removeReject('paragraphs',index)">
                                            <i class="fa fa-times"></i>
                                            <span class="m-0 p-0">Remove these comments</span>
                                        </button>
                                    </div>
                                </div>
                                <ui-textarea autoresize v-model="rejectData.paragraphs[index]"
                                             v-if="!readonly"></ui-textarea>
                                <div v-else
                                     class="bg-white m-0 px-3 py-2 relative rounded-md shadow-sm block w-full border sm:text-sm focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 border-gray-300 placeholder-gray-400"
                                     v-text="rejectData.paragraphs[index]"></div>

                            </div>
                        </div>
                    </div>
                    <div class="text-3xl font-semibold text-gray-900 mt-4">Health Risks</div>
                    <div class="text-gray-700">
                        <div v-for="(field,index) in rams.healthRisks" class="px-3 py-3 rounded-xl border-0 mt-1"
                             :class="((rejectMode && !readonly)?'hover:bg-red-50 cursor-pointer ':'')+((rejectMode && (typeof rejectData.healthRisks[index] !== 'undefined'))?'bg-red-50':'bg-white')"
                             @click="addReject('healthRisks',index)"
                        >
                            <h3 class="font-semibold mt-3 text-gray-700 mb-1.5">{{ field.hazard }}</h3>
                            <div class="flex items-start mb-1">
                                <div class="w-20 text-right text-gray-400 text-sm pt-1 min-h-[58px]">Risk:</div>
                                <div
                                    class="flex-1 mx-1 px-2 whitespace-pre-wrap border border-gray-300 rounded min-h-[58px]"
                                    v-text="field.hazardRisk"
                                ></div>
                                <div class="w-40 flex-shrink-0">
                                    <div
                                        class="flex border border-gray-300 rounded px-2 py-1 min-h-[58px]">
                                        <div class="flex-1">
                                            <div class="text-xs text-gray-400">Without Controls</div>
                                            <div class="text-xs text-gray-600 pl-1">
                                                <div>Likelihood: <span class="text-gray-600"
                                                                       v-text="field.harmWithoutControls.likelihoodOfHarm?field.harmWithoutControls.likelihoodOfHarm:'?'"></span>
                                                </div>
                                                <div>Severity: <span class="text-gray-600"
                                                                     v-text="field.harmWithoutControls.severityOfHarm?field.harmWithoutControls.severityOfHarm:'?'"></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div
                                                class="rounded-full w-10 h-10 bg-green-300 border-gray-200 mt-1.5 pt-2 text-center text-white"
                                                v-text="field.harmWithoutControls.likelihoodOfHarm * field.harmWithoutControls.severityOfHarm"
                                                :style="'background: '+getColor(field.harmWithoutControls.likelihoodOfHarm * field.harmWithoutControls.severityOfHarm)">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex items-start mb-1">
                                <div class="w-20 flex-shrink-0 text-right text-gray-400 text-sm pt-1 min-h-[58px]">
                                    Controls:
                                </div>
                                <div
                                    class="flex-1 mx-1 px-2 whitespace-pre-wrap border border-gray-300 rounded min-h-[58px]"
                                    v-text="field.controls"
                                ></div>
                                <div class="w-40 flex-shrink-0">
                                    <div
                                        class="flex border border-gray-300 rounded px-2 py-1 min-h-[58px]">
                                        <div class="flex-1">
                                            <div class="text-xs text-gray-400">With Controls</div>
                                            <div class="text-xs text-gray-600 pl-1">
                                                <div>Likelihood: <span class="text-gray-600"
                                                                       v-text="field.harmWithControls.likelihoodOfHarm?field.harmWithControls.likelihoodOfHarm:'?'"></span>
                                                </div>
                                                <div>Severity: <span class="text-gray-600"
                                                                     v-text="field.harmWithControls.severityOfHarm?field.harmWithControls.severityOfHarm:'?'"></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div
                                                class="rounded-full w-10 h-10 bg-green-300 border-gray-200 mt-1.5 pt-2 text-center text-white"
                                                v-text="field.harmWithControls.likelihoodOfHarm * field.harmWithControls.severityOfHarm"
                                                :style="'background: '+getColor(field.harmWithControls.likelihoodOfHarm * field.harmWithControls.severityOfHarm)">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="p-2 text-red-500"
                                 :ref="'healthRisks_'+index"
                                 v-if="rejectMode && (typeof rejectData.healthRisks[index] !== 'undefined')">
                                <div class="flex">
                                    <label>Your rejection comments:</label>
                                    <div>
                                        <button v-if="!readonly"
                                                class="px-2 py-1 text-xs text-gray-600 hover:text-red-600 border ml-2 border-gray-200 rounded-lg bg-white"
                                                @click="removeReject('healthRisks',index)">
                                            <i class="fa fa-times"></i>
                                            <span class="m-0 p-0">Remove Comments</span>
                                        </button>
                                    </div>
                                </div>
                                <ui-textarea autoresize v-model="rejectData.healthRisks[index]"
                                             v-if="!readonly"></ui-textarea>
                                <div v-else
                                     class="bg-white m-0 px-3 py-2 relative rounded-md shadow-sm block w-full border sm:text-sm focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 border-gray-300 placeholder-gray-400"
                                     v-text="rejectData.healthRisks[index]"></div>
                            </div>
                        </div>
                    </div>
                    <div class="text-3xl font-semibold text-gray-900 mt-4">Safety Risks</div>
                    <div class="text-gray-700">
                        <div v-for="(field,index) in rams.safetyRisks" class="px-3 py-3 rounded-xl border-0 mt-1"
                             :class="((rejectMode && !readonly)?'hover:bg-red-50 cursor-pointer ':'')+((rejectMode && (typeof rejectData.safetyRisks[index] !== 'undefined'))?'bg-red-50':'bg-white')"
                             @click="addReject('safetyRisks',index)"
                        >
                            <h3 class="font-semibold mt-3 text-gray-700 mb-1.5">{{ field.hazard }}</h3>
                            <div class="flex items-start mb-1">
                                <div class="w-20 text-right text-gray-400 text-sm pt-1 min-h-[58px]">Risk:</div>
                                <div
                                    class="flex-1 mx-1 px-2 whitespace-pre-wrap border border-gray-300 rounded min-h-[58px]"
                                    v-text="field.hazardRisk"
                                ></div>
                                <div class="w-40 flex-shrink-0">
                                    <div
                                        class="flex border border-gray-300 rounded px-2 py-1 min-h-[58px]">
                                        <div class="flex-1">
                                            <div class="text-xs text-gray-400">Without Controls</div>
                                            <div class="text-xs text-gray-600 pl-1">
                                                <div>Likelihood: <span class="text-gray-600"
                                                                       v-text="field.harmWithoutControls.likelihoodOfHarm?field.harmWithoutControls.likelihoodOfHarm:'?'"></span>
                                                </div>
                                                <div>Severity: <span class="text-gray-600"
                                                                     v-text="field.harmWithoutControls.severityOfHarm?field.harmWithoutControls.severityOfHarm:'?'"></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div
                                                class="rounded-full w-10 h-10 bg-green-300 border-gray-200 mt-1.5 pt-2 text-center text-white"
                                                v-text="field.harmWithoutControls.likelihoodOfHarm * field.harmWithoutControls.severityOfHarm"
                                                :style="'background: '+getColor(field.harmWithoutControls.likelihoodOfHarm * field.harmWithoutControls.severityOfHarm)">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex items-start mb-1">
                                <div class="w-20 flex-shrink-0 text-right text-gray-400 text-sm pt-1 min-h-[58px]">
                                    Controls:
                                </div>
                                <div
                                    class="flex-1 mx-1 px-2 whitespace-pre-wrap border border-gray-300 rounded min-h-[58px]"
                                    v-text="field.controls"
                                ></div>
                                <div class="w-40 flex-shrink-0">
                                    <div
                                        class="flex border border-gray-300 rounded px-2 py-1 min-h-[58px]">
                                        <div class="flex-1">
                                            <div class="text-xs text-gray-400">With Controls</div>
                                            <div class="text-xs text-gray-600 pl-1">
                                                <div>Likelihood: <span class="text-gray-600"
                                                                       v-text="field.harmWithControls.likelihoodOfHarm?field.harmWithControls.likelihoodOfHarm:'?'"></span>
                                                </div>
                                                <div>Severity: <span class="text-gray-600"
                                                                     v-text="field.harmWithControls.severityOfHarm?field.harmWithControls.severityOfHarm:'?'"></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div
                                                class="rounded-full w-10 h-10 bg-green-300 border-gray-200 mt-1.5 pt-2 text-center text-white"
                                                v-text="field.harmWithControls.likelihoodOfHarm * field.harmWithControls.severityOfHarm"
                                                :style="'background: '+getColor(field.harmWithControls.likelihoodOfHarm * field.harmWithControls.severityOfHarm)">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="p-2 text-red-500"
                                 :ref="'safetyRisks_'+index"
                                 v-if="rejectMode && (typeof rejectData.safetyRisks[index] !== 'undefined')">
                                <div class="flex">
                                    <label>Your rejection comments:</label>
                                    <div>
                                        <button v-if="!readonly"
                                                class="px-2 py-1 text-xs text-gray-600 hover:text-red-600 border ml-2 border-gray-200 rounded-lg bg-white"
                                                @click="removeReject('safetyRisks',index)">
                                            <i class="fa fa-times"></i>
                                            <span class="m-0 p-0">Remove Comments</span>
                                        </button>
                                    </div>
                                </div>
                                <ui-textarea autoresize v-model="rejectData.safetyRisks[index]"
                                             v-if="!readonly"></ui-textarea>
                                <div v-else
                                     class="bg-white m-0 px-3 py-2 relative rounded-md shadow-sm block w-full border sm:text-sm focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 border-gray-300 placeholder-gray-400"
                                     v-text="rejectData.safetyRisks[index]"></div>
                            </div>
                        </div>
                    </div>
                    <div v-if="rams.response && rams.response.signature" class="lg:hidden block mt-4">
                        <p class="text-sm mt-1" v-if="rams.response">Approved by: <span
                            class="font-semibold">{{ rams.response.name }}</span></p>
                        <p class="text-sm mt-1" v-if="rams.response">Signed:</p>
                        <img v-if="rams.response.signature" :src="rams.response.signature"
                             style="width:100%; margin: 5px; max-width: 350px">
                    </div>
                    <div class="text-3xl font-semibold text-gray-900 mt-4"
                         v-if="rams.attendees && rams.attendees.length">Attendee's
                    </div>
                    <div class="text-gray-700" v-if="rams.attendees && rams.attendees.length">
                        <table style="width:100%; border-collapse: collapse;margin-top:10px;">
                            <tr>
                                <td style="vertical-align:top; background-color:#eee; border: 1px solid #ccc; padding:8px 13px 8px 13px; width:47%">
                                    <strong>Name</strong>
                                </td>
                                <td style="background-color:#eee; border: 1px solid #ccc; padding:8px 14px 8px 13px;width:47%">
                                    <strong>Position</strong>
                                </td>
                                <td style="background-color:#eee; border: 1px solid #ccc; padding:8px 14px 8px 13px; width:6%">
                                    <strong>Signature</strong>
                                </td>
                            </tr>
                            <tr v-for="attendee in rams.attendees">
                                <td style="vertical-align:top; border: 1px solid #ccc;padding:8px 14px 8px 13px;">
                                    {{ attendee.name }}
                                </td>
                                <td style="vertical-align:top; border: 1px solid #ccc;padding:8px 14px 8px 13px;">
                                    {{ attendee.position }}
                                </td>
                                <td class="" style="border: 1px solid #ccc;padding:0px; text-align: center">
                                    <img :src="attendee.signature" v-if="attendee.signature"
                                         style="width:100%; margin-top:1px; padding:0px">
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import {RAMS} from '@models'
import moment from "moment";
import UiDropdown from "../../../ui/UiDropdown.vue";
import RamsRiskDropdown from "../RamsRiskDropdown.vue";
import UiTextarea from "../../../ui/UiTextarea.vue";
import UiDropdownItem from "../../../ui/UiDropdownItem.vue";
import UiIconPicker from "../../../ui/UiIconPicker.vue";
import AutoresizableTextarea from "../../../ui/AutoresizableTextarea";
import UiButtonNew from "../../../ui/UiButtonNew.vue";

export default {
    components: {
        UiButtonNew,
        AutoresizableTextarea, UiIconPicker, UiDropdownItem, UiTextarea, RamsRiskDropdown, UiDropdown
    },
    props: {
        rams: Object,
    },
    data() {
        return {
            rejectMode: false,
            rejectData: {
                paragraphs: [],
                healthRisks: [],
                safetyRisks: [],
            },
            readonly: false,
            renderKey: 0,
            moment,
        }
    },
    computed: {},
    methods: {
        getColor(num) {
            return RAMS.getColor(num);
        },
        print(url) {
            if (!this.iframe) {
                this.iframe = document.createElement('iframe');
                this.iframe.setAttribute('style', 'display:none');
                this.iframe.src = "";
                this.iframe.name = 'pdf';
                this.iframe.onload = () => {
                    this.$nextTick(() => {
                            setTimeout(() => {
                                const pdfFrame = window.frames["pdf"];
                                pdfFrame.focus();
                                pdfFrame.print();
                            }, 100)
                        }
                    )
                }
                document.body.appendChild(this.iframe);
            }
            this.iframe.src = url + '?time=' + moment().format('x')
        },
        download() {
            window.location.href = window.location.href + '/pdf';
        },
        approve() {
            this.$modals.open('rams-approve', {
                title: `Approve this RAMS`,
                button: 'I approve this RAMS',
                handle: async (data, modal) => {
                    await Http.post(window.location.href, {name: data.name, signature: data.signature})
                    window.location.reload()
                }
            })
        },
        reject() {
            this.$modals.open('rams-reject', {
                title: `Rejecting this RAMS`,
                button: 'I reject this RAMS',
                rejectData: this.rejectData,
                rams: this.rams,
                handle: async (data, modal) => {
                    await Http.post(window.location.href, {
                        name: data.name,
                        comment: data.comment,
                        perItemComments: this.rejectData
                    })
                    window.location.reload()
                }
            })
        },
        addReject(type, index) {
            if (!this.readonly) {
                if (typeof this.rejectData[type][index] === "undefined") {
                    this.rejectData[type][index] = '';
                    this.renderKey++;
                    this.$nextTick(() => {
                        this.$refs[type + '_' + index][0].scrollIntoView({behavior: 'smooth', block: 'center'});
                    })
                }
            }
        },
        removeReject(type, index) {
            delete this.rejectData[type][index];
            this.renderKey++;
        }

    },
    async mounted() {
        if (this.rams.response) {
            this.readonly = true
        }
        if (this.rams.response && this.rams.response.perItemComments) {
            this.rejectData.paragraphs = this.rams.response.perItemComments.paragraphs
            this.rejectData.safetyRisks = this.rams.response.perItemComments.safetyRisks
            this.rejectData.healthRisks = this.rams.response.perItemComments.healthRisks
            this.rejectMode = true;
        }
    },
}
</script>
